import React from "react";
import {Step} from "../api/model/scenario";
import {TravelQuotation} from "../model/quotation";

interface Props {
    currentStep: Step;
    setCurrentStep: React.Dispatch<React.SetStateAction<Step>>;
    previousStep: Step;
    setPreviousStep: React.Dispatch<React.SetStateAction<Step>>;
    nextStageHandler: (quotation: TravelQuotation) => void;
    backStageHandler: (quotation: TravelQuotation) => void;
}

export const TravelScenarioContext = React.createContext<Props>({
    currentStep: null,
    setCurrentStep: () => {},
    previousStep: null,
    setPreviousStep: () => {},
    nextStageHandler: () => {},
    backStageHandler: () => {}
});